// extracted by mini-css-extract-plugin
export default {"scrollBox":"Ey3dxBKzYPrMDZ5yw6XQ","outBox":"_AG73UcvXgMMmGkWN8jt","contentWrapper":"P_ocQyEVun8Hvfr18Fmw","withScrollIndent":"xv0EisqTJ38MIeR2XfLF","inBox":"uYy3u3e1Qh75wJajeK1f"};